'use client';

import { PropsWithChildren, useEffect, useState } from 'react';
import { IconArrowRight, IconArrowSquareDown, IconArrowSquareLeft } from '@/components/svg-symbols/icons';
import { Button } from '../button';
import { AppButton } from '../product-card/app-button';
type Props = PropsWithChildren & {
  search?: React.ReactNode;
  title: string;
  defaultState?: 'open' | 'closed';
  onStateChange?: (state: boolean) => void;
  mode?: 'desktop' | 'mobile';
  uniqueKey: string;
};
export function ExpandablePanel({
  children,
  title,
  defaultState,
  onStateChange,
  mode = 'desktop',
  search,
  uniqueKey
}: Props) {
  const [isChecked, setIsChecked] = useState<boolean>(defaultState === 'open');
  const isMobile = mode === 'mobile';
  const setStateChange = (state: boolean) => {
    if (onStateChange) {
      onStateChange(state);
    }
  };
  const onChangeStatus = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newState = event.target.checked;
    const mobileFaceDrwer = document.querySelector('.mobile-facet');
    if (mobileFaceDrwer) {
      mobileFaceDrwer.scrollTop = 0;
      if (newState) mobileFaceDrwer.classList.add('overflow-y-hidden');else mobileFaceDrwer.classList.remove('overflow-y-hidden');
    }
    setIsChecked(newState);
    setStateChange(newState);
  };

  // handle URL hash
  useEffect(() => {
    if (!isMobile) return;
    if (isChecked) {
      window.location.hash = title;
    } else {
      // remove overflow on mobile-facet - in case user used back button
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
      document.querySelector('.mobile-facet')?.classList.remove('overflow-y-hidden');
    }
  }, [isChecked, title, isMobile]);
  useEffect(() => {
    const handleHashChange = () => {
      setIsChecked(decodeURIComponent(window.location.hash) === '#' + title);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [title]);
  return <div className='relative flex h-fit w-full flex-wrap items-center' data-sentry-component="ExpandablePanel" data-sentry-source-file="expandable-panel.tsx">
            <input type='checkbox' className='peer/panel hidden' onChange={e => onChangeStatus(e)} id={uniqueKey} value={`${title}-${mode}-panel`} checked={isChecked} />
            <label htmlFor={uniqueKey} className={'flex grow cursor-pointer items-center justify-between px-2 py-2.5 lg:py-3 lg:transition-all lg:duration-200 lg:ease-in-out peer-checked/panel:[&>svg]:rotate-180'}>
                <span className='text-body-14 text-text-black lg:text-body-16'>{title}</span>

                {mode === 'mobile' && <IconArrowSquareLeft className='h-6 w-6 text-text-black' />}
                {mode === 'desktop' && <IconArrowSquareDown className='h-6 w-6 transform text-text-black transition-all duration-200' />}
            </label>

            <div className='hidden w-full flex-col items-start overflow-hidden rounded-md bg-white peer-checked/panel:fixed peer-checked/panel:right-0 peer-checked/panel:top-0 peer-checked/panel:z-10 peer-checked/panel:flex peer-checked/panel:h-screen peer-checked/panel:w-screen peer-checked/panel:overflow-auto lg:flex lg:max-h-0 lg:bg-transparent lg:transition-all lg:duration-300 peer-checked/panel:lg:relative peer-checked/panel:lg:h-fit peer-checked/panel:lg:max-h-96 peer-checked/panel:lg:w-full'>
                {mode === 'mobile' && <label className='relative flex w-full items-center justify-center gap-4 p-4 text-body-16 font-medium shadow-sm' htmlFor={uniqueKey}>
                        <IconArrowRight className='absolute right-4 h-6 w-6 cursor-pointer' />
                        <span>{title}</span>
                    </label>}

                <div className='hide-scrollbar h-[calc(100dvh_-_133px)] w-full overflow-y-auto text-sm leading-6 lg:h-auto lg:text-base'>
                    <div className='flex flex-col px-2 py-3 lg:px-0 lg:py-0'>
                        {search && <div className='w-full lg:px-2 lg:py-1'>{search}</div>}

                        {children}
                    </div>
                </div>

                {mode === 'mobile' && <AppButton className='fixed bottom-0 right-0' isSingleButton>
                        <Button graphicStyle='filled' size='large' onClick={e => {
          e.currentTarget.querySelector('label')?.click();
        }}>
                            <label htmlFor={uniqueKey} className='hidden'>
                                <span className='sr-only'>Close panel</span>
                            </label>
                            تایید
                        </Button>
                    </AppButton>}
            </div>
        </div>;
}